type fontProps = {
  [key: string]: number;
};

const Font: fontProps = {
  titleFont: 50,
};

export default Font;
